import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ThemeService } from 'src/app/services/theme/theme.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    TranslateModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarComponent implements OnInit {
  @Output() eventOpenSidnav: EventEmitter<boolean> = new EventEmitter();
  public isLogged$: BehaviorSubject<boolean> = this.authService.userLogged();
  public activeTheme$: BehaviorSubject<string> = new BehaviorSubject<string>(
    ''
  );

  public openedSidenav: boolean = false;

  constructor(
    private readonly authService: AuthService,
    private readonly themeService: ThemeService
  ) {}

  public ngOnInit(): void {
    this.activeTheme$.next(this.themeService.loadTheme()!);
  }

  public toggleTheme() {
    this.activeTheme$.next(this.themeService.toggleTheme());
  }

  public openCloseSidenav(): void {
    this.openedSidenav = !this.openedSidenav;
    this.eventOpenSidnav.emit(this.openedSidenav);
  }
}
